import { apiClient } from './apiClient.js'

export const passwordSettingsApi = {
    fetchPasswordSettings: async (beId, config, accessToken) => {
        const url = `${config.securityApiUrl}/businessEntities/${beId}/passwordSettings`
        return await apiClient(
            url,
            accessToken,
            {
                method: "GET"
            },
            async (response) => {
                return await response.json().then(
                    (result) => {
                        //console.log("Returning the following password settings:")
                        //console.log(result)
                        return result.passwordSettings[0]
                    }
                )
            }
        )
    }
}